export default __webpack_public_path__ + "static/media/Precious Plastic - Presentation - Deck.6dda8dd5.pdf";